import { useRef, useState, useCallback, useEffect } from "react";
import { useSpring } from "react-spring";
import { useDrag } from "react-use-gesture";
import { clamp } from "../helpers";

export default function useSlider({ initialSlide, slides, carouselWidth }) {
  const [{ x, scale }, set] = useSpring(() => ({
    x: typeof window !== "undefined" ? -carouselWidth * initialSlide : 0,
    scale: 1,
    config: { tension: 270, clamp: true },
  }));

  const index = useRef(initialSlide);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     MoveToNextSlide();
  //   }, 1000);
  //   return () => MoveToNextSlide();
  // }, []);

  // const MoveToNextSlide = (slideNumber = 0) => {
  //   console.log("here", slideNumber + 1);
  //   set({
  //     x: (-slideNumber + 1) * carouselWidth + -360,
  //     immediate: false,
  //   });
  //   updateSlide(slideNumber + 1);
  //   setTimeout(() => {
  //     MoveToNextSlide(slideNumber + 1);
  //   }, 1000);
  // };
  // Slide numbers (for display purposes only)
  const [currentSlide, updateSlide] = useState(initialSlide);
  const [zooming, setZooming] = useState(false);

  const onScale = useCallback(
    (slideProps) => {
      set({ scale: slideProps.scale });
      if (slideProps.scale === 1) {
        setZooming(false);
      } else {
        setZooming(true);
      }
    },
    [set]
  );

  const updateSlideAnimate = (slideNumber) => {
    set({
      x: -slideNumber * carouselWidth,
      immediate: false,
    });

    // Update the slide number for display purposes
    index.current = slideNumber;
    updateSlide(slideNumber);
  };
  const bind = useDrag(
    ({
      down,
      movement: [xMovement],
      direction: [xDir],
      distance,
      swipe: [swipeX],
      cancel,
      touches,
    }) => {
      // We don't want to interrupt the pinch-to-zoom gesture
      if (touches > 1) {
        cancel();
      }
      // We have swiped past halfway
      if (!down && distance > carouselWidth / 2) {
        // Move to the next slide
        const slideDir = xDir > 0 ? -1 : 1;
        index.current = clamp(index.current + slideDir, 0, slides.length - 1);

        set({
          x: -index.current * carouselWidth + (down ? xMovement : 0),
          immediate: false,
        });
      } else if (swipeX !== 0) {
        // We have detected a swipe - update the new index
        index.current = clamp(index.current - swipeX, 0, slides.length - 1);
      }

      // Animate the transition
      set({
        x: -index.current * carouselWidth + (down ? xMovement : 0),
        immediate: down,
      });

      // Update the slide number for display purposes
      updateSlide(index.current);
    },
    {
      axis: "x",
      bounds: {
        left: currentSlide === slides.length - 1 ? 0 : -Infinity,
        right: index.current === 0 ? 0 : Infinity,
        top: 0,
        bottom: 0,
      },
      rubberband: true,
      enabled: slides.length > 1,
    }
  );

  return [zooming, scale, currentSlide, bind, x, onScale, updateSlideAnimate];
}
